module.exports = __webpack_public_path__ + "face_expression_model-shard1.shard";